const state = {
  currencies: [
    {
      symbol: '£',
      abbrv: 'GBP',
      name: 'Great Britain Pound',
    },
    {
      symbol: '€',
      abbrv: 'EUR',
      name: 'Euro',
    },
    {
      symbol: '$',
      abbrv: 'USD',
      name: 'USA Dollar',
    },
    {
      symbol: 'CHF',
      abbrv: 'CHF',
      name: 'Switzerland Franc',
    },
  ],
}

const getters = {
  currencies: (state) => {
    return state.currencies
  },
}

const mutations = {}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions,
}
